module.exports = __webpack_public_path__ + "static/media/whatsapp.60acc4f3.svg";